import { useEffect, useState, ChangeEvent, useMemo } from "react";
import { getLatestStudents, createStudent } from "../../api/students";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Divider, Group, Input, Modal } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { NewStudent } from "../../types";
import { MantineReactTable } from "mantine-react-table";

const Latest = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [students, setStudents] = useState([]);
  const [opened, { open, close }] = useDisclosure(false);
  const [accessToken, setAccessToken] = useState("");
  const [newStudent, setNewStudent] = useState<NewStudent>({
    name: "",
    surname: "",
    email: "",
  });
  const navigate = useNavigate();

  const getStudents = async (token) => {
    setStudents(await getLatestStudents(token));
  };

  async function handleSubmit(event: ChangeEvent<HTMLFormElement>) {
    event.preventDefault();

    const response = await createStudent(accessToken, newStudent);
    close();
    getStudents(accessToken);
    return response;
  }

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    setNewStudent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  useEffect(() => {
    async function getToken() {
      const token = await getAccessTokenSilently();
      setAccessToken(token);
      getStudents(token);
    }
    getToken();
  }, [getAccessTokenSilently]);

  const columns = useMemo(
    () => [
      {
        header: "Ime",
        accessorKey: "name",
      },
      {
        header: "Priimek",
        accessorKey: "surname",
      },
    ],
    []
  );

  return (
    <>
      <MantineReactTable
        columns={columns}
        data={students}
        mantineTableBodyRowProps={({ row }) => ({
          onClick: () => {
            navigate("/student-details", { state: row.original });
          },
          sx: {
            cursor: "pointer",
          },
        })}
        //options
        enablePagination
        enableFullScreenToggle={false}
        enableDensityToggle={false}
        enableColumnFilters={false}
        enableHiding={false}
        enableRowSelection={false}
        enableColumnOrdering={false}
        enableGlobalFilter
      />

      <Divider size="lg" my="lg" />
      <Button onClick={open} key="Dodaj učenca">
        Dodaj učenca
      </Button>

      <Modal opened={opened} onClose={close} title="Dodaj novega učenca">
        <form onSubmit={handleSubmit}>
          <Input.Wrapper label="Ime" size="md">
            <Input
              placeholder="Ime"
              value={newStudent.name}
              name="name"
              onChange={handleInputChange}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Priimek" size="md">
            <Input
              placeholder="Priimek"
              value={newStudent.surname}
              name="surname"
              onChange={handleInputChange}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Email" size="md">
            <Input
              placeholder="Email"
              value={newStudent.email}
              name="email"
              onChange={handleInputChange}
            />
          </Input.Wrapper>
          <Divider size="sm" my="sm" />
          <Group>
            <Button type="submit" color="blue">
              <p>Dodaj</p>
            </Button>
            <Button color={"red"} onClick={close}>
              Prekliči
            </Button>
          </Group>
        </form>
      </Modal>
    </>
  );
};

export default Latest;
